import { faAngleDown, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from 'i18n';
import { useCallback, useMemo, useState } from 'react';
import styles from './batchEditCampaignTitle.module.scss';
import { NameWithIdColumn } from 'components/TableColumn/NameWithIdColumn';

export const BatchEditCampaignTitle: React.FC<
  React.PropsWithChildren<{
    campaigns: {
      id: number;
      name: string;
    }[];
  }>
> = ({ campaigns }) => {
  const [showDetail, setShowDetail] = useState(false);
  const toggleShowDetail = useCallback(() => {
    setShowDetail((show) => !show);
  }, []);

  const campaignRows = useMemo(() => {
    return campaigns.map((campaign) => (
      <div className={styles.campaignRow} key={campaign.id}>
        <NameWithIdColumn
          id={campaign.id}
          name={campaign.name}
          clickable={false}
        />
      </div>
    ));
  }, [campaigns]);

  return (
    <div className={styles.batchEditCampaignTitle}>
      <div onClick={toggleShowDetail} className={styles.title}>
        <h4>
          {i18n.t('batchEditCampaignTitle.title', {
            num: campaigns.length
          })}
        </h4>
        <FontAwesomeIcon icon={showDetail ? faAngleDown : faAngleRight} />
      </div>
      {showDetail && (
        <div>
          <div className={styles.subTitle}>
            {i18n.t('batchEditCampaignTitle.labels.subTitle')}
          </div>
          {campaignRows}
        </div>
      )}
    </div>
  );
};

export const renderBatchEditCampaignTitle = (
  campaigns: {
    id: number;
    name: string;
  }[]
): React.JSX.Element => {
  return <BatchEditCampaignTitle campaigns={campaigns} />;
};
